import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useHardwareOverviewStore = createStore(
  (set) => ({
    sorting: { ...initialSorting },

    actions: {
      setSorting: (sorting) => set({ sorting }),
    },
  }),
  'HardwareOverviewStore',
);

export const useHardwareOverviewActions = () => useHardwareOverviewStore((state) => state.actions);

export const selectHardwareOverviewSorting = () => useHardwareOverviewStore((state) => state.sorting);
